import { render, staticRenderFns } from "./RightSuspension.vue?vue&type=template&id=125fbc3c&scoped=true&"
import script from "./RightSuspension.vue?vue&type=script&lang=js&"
export * from "./RightSuspension.vue?vue&type=script&lang=js&"
import style0 from "./RightSuspension.vue?vue&type=style&index=0&id=125fbc3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125fbc3c",
  null
  
)

export default component.exports